import React, { useState } from "react";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { Button } from "@material-ui/core";


export const featureCategories = [
  {
    name: "Account Access",
    features: [
      { name: "User Limit", standard: "5 Users", plus: "15 Users", professional: "25 Users" },
    ],
  },
  {
    name: "CMS Features",
    features: [
      { name: "Dashboard Access", standard: true, plus: true, professional: true },
      { name: "Content Management", standard: true, plus: true, professional: true },
      { name: "Media Library", standard: true, plus: true, professional: true },
      { name: "User Roles", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "Scheduling",
    features: [
      { name: "Calendar View", standard: true, plus: true, professional: true },
      { name: "Appointment Booking", standard: true, plus: true, professional: true },
      { name: "Resource Allocation", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "Client Manager",
    features: [
      { name: "Client Database", standard: true, plus: true, professional: true },
      {
        name: "Communication History",
        standard: true,
        plus: true,
        professional: true,
      },
      { name: "Document Storage", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "Employee Manager",
    features: [
      { name: "Staff Profiles", standard: true, plus: true, professional: true },
      {
        name: "Performance Tracking",
        standard: true,
        plus: true,
        professional: true,
      },
      { name: "Schedule Management", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "Reports",
    features: [
      { name: "Basic Analytics", standard: true, plus: true, professional: true },
      { name: "Custom Reports", standard: true, plus: true, professional: true },
      { name: "Data Export", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "Notifications (Email/Push)",
    features: [
      { name: "Automated Reminders", standard: true, plus: true, professional: true },
      { name: "Custom Templates", standard: true, plus: true, professional: true },
      { name: "Scheduled Sending", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "SMS Notifications",
    features: [
      { name: "Text Alerts", standard: true, plus: true, professional: true },
      { name: "Two-Way Messaging", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "Alerts",
    features: [
      { name: "Custom Triggers", standard: true, plus: true, professional: true },
      { name: "Team Notifications", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "Supplies Management",
    features: [
      { name: "Inventory Tracking", standard: true, plus: true, professional: true },
      { name: "Order Management", standard: true, plus: true, professional: true },
    ],
  },
  {
    name: "Issues Management",
    features: [
      { name: "Ticket System", standard: true, plus: true, professional: true },
      { name: "Resolution Tracking", standard: true, plus: true, professional: true },
    ],
  },
];

const FeatureTable = () => {
  const [expandedIndex, setExpandedIndex] = useState(null);

  const handleChange = (index) => {
    setExpandedIndex(expandedIndex === index ? null : index);
  };
  return (
    <div className="feature-table-container dark:shadow-[0_0_12px_rgba(2,8,23,0.8)]">
      <div className="feature-table-header">
        <div className="feature-col">Features</div>
        <div className="feature-col">
          Standard <div className="price">($99/month)</div>
        </div>
        <div className="feature-col">
          Plus <div className="price">($249/month)</div>
        </div>
        <div className="feature-col">
          Professional <div className="price">($375/month)</div>
        </div>
      </div>

      {featureCategories?.map((category, index) => (
        <Accordion
          key={index}
          className="m-0"
          expanded={expandedIndex === index}
          onChange={() => handleChange(index)}

          style={{ border: "none" }}
        >
          <AccordionSummary
            className="p-0 summaryAcc bg-slate-100 dark:bg-[#1A1F2C] dark:shadow-[0_0_8px_rgba(2,8,23,0.8)]"
          >
            <div className="feature-row1 text-gray-900 dark:text-white">
              <div className="feature-col feature-title ph-10 p-0 boxSizing dark:text-white">
                {category?.name}
              </div>
              {expandedIndex === index ? (
                <ExpandLessIcon className="dark:text-white" />
              ) : (
                <ExpandMoreIcon className="dark:text-white" />
              )}
            </div>
            <div className="feature-col p-0 d-flex flex-center flex-justify-center">
              {renderIcon(true)}
            </div>
            <div className="feature-col p-0 d-flex flex-center flex-justify-center">
              {renderIcon(true)}
            </div>
            <div className="feature-col p-0 d-flex flex-center flex-justify-center">
              {renderIcon(true)}
            </div>
          </AccordionSummary>
          <AccordionDetails className="bg-white dark:bg-[#1A1F2C] text-gray-900 dark:text-white">
            {category?.features?.map((feature, i) => (
              <div key={i} className="feature-row dark:bg-[#334155]">
                <div className="feature-col feature-name dark:text-white">- {feature?.name}</div>
                <div className="feature-col d-flex flex-center flex-justify-center">
                  {renderIcon(feature?.standard)}
                </div>
                <div className="feature-col d-flex flex-center flex-justify-center">
                  {renderIcon(feature?.plus)}
                </div>
                <div className="feature-col d-flex flex-center flex-justify-center">
                  {renderIcon(feature?.professional)}
                </div>
              </div>
            ))}
          </AccordionDetails>
        </Accordion>
      ))}
    </div>
  );
};

const renderIcon = (value) => {
  if (typeof value === "string") {
    return <span className="text-gray-800 dark:text-white">{value}</span>;
  }
  return value ? (
    <CheckIcon className="icon-check text-green-600 dark:text-green-400" />
  ) : (
    <CloseIcon className="icon-close text-red-600 dark:text-red-400" />
  );
};

const ToggleFeatureButton = ({ isOpen, onToggle }) => {
  if (!isOpen) {
    return (
      <div className="toggle-button-wrapper">
        <Button onClick={onToggle} className="toggle-button dark:text-white">
          <ExpandMoreIcon className="mr-1 h-4 w-4 dark:text-white" />
          View full feature comparison
        </Button>
      </div>
    );
  }

  return (
    <div className="toggle-button-wrapper">
      <Button onClick={onToggle} className="toggle-button dark:text-white">
        <ChevronRightIcon className="mr-1 h-4 w-4 dark:text-white" />
        Hide feature comparison
      </Button>
    </div>
  );
};

const FeatureComparison = ({ isOpen, setIsOpen }) => {
  return (
    <div>
      <ToggleFeatureButton
        isOpen={isOpen}
        onToggle={() => setIsOpen(!isOpen)}
      />

      {isOpen && <FeatureTable />}
    </div>
  );
};

export default FeatureComparison;